<template>
  <div class="d-flex align-center justify-space-between">
    <div>Легенда:</div>

    <div class="d-flex">
      <div class="col py-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="col btn-legend" dark v-bind="attrs" v-on="on" :style="{ backgroundColor: green }"></v-btn>
            <div class="mt-1">Нормальный</div>
          </template>
          <div style="font-size: 16px"></div>
        </v-tooltip>
      </div>

      <div class="col py-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="col btn-legend" dark v-bind="attrs" v-on="on" :style="{ backgroundColor: yellow }"></v-btn>
            <div class="mt-1">Пограничный</div>
          </template>
          <div style="font-size: 16px"></div>
        </v-tooltip>
      </div>

      <div class="col py-0">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="col btn-legend" dark v-bind="attrs" v-on="on" :style="{ backgroundColor: red }"></v-btn>
            <div class="mt-1">Критичный</div>
          </template>
          <div style="font-size: 16px"></div>
        </v-tooltip>
      </div>
    </div>

    <div></div>
  </div>
</template>

<script>
import { LegendExcessMeasurement } from "@/configs/legenda.js";

export default {
  name: "GroupLegendIndexOfHealth",

  computed: {
    green() {
      return LegendExcessMeasurement.green;
    },

    yellow() {
      return LegendExcessMeasurement.yellow;
    },

    red() {
      return LegendExcessMeasurement.red;
    },
  },
};
</script>

<style scoped lang="scss">
.v-sheet button.v-btn.btn-legend.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 0 !important;
  height: 20px;
}
</style>
